import React from "react";
import { motion } from "framer-motion";

const items = [
  { url: "https://images.pexels.com/photos/9335961/pexels-photo-9335961.jpeg", span: "row-span-2", label: "Signature Facial" },
  { url: "https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?w=800&q=80", span: "", label: "Precision Brows" },
  { url: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=800&q=80", span: "", label: "Studio Corner" },
  { url: "https://images.unsplash.com/photo-1707851621528-c50882570d7c?w=800&q=80", span: "row-span-2", label: "Gold Polish Glow" },
  { url: "https://images.pexels.com/photos/37229288/pexels-photo-37229288.jpeg", span: "", label: "Facial Massage" },
  { url: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80", span: "", label: "Post Treatment" },
  { url: "https://images.unsplash.com/photo-1596178065887-1198b6148b2b?w=800&q=80", span: "col-span-2", label: "Serene Details" },
];

const beforeAfter = [
  {
    before: "https://images.unsplash.com/photo-1554446422-d05db23719d2?w=600&q=80",
    after: "https://images.unsplash.com/photo-1596178065887-1198b6148b2b?w=600&q=80",
    label: "Anti-Aging Ritual · 3 sessions",
  },
  {
    before: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=600&q=80",
    after: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=600&q=80",
    label: "Acne Clarifying Facial · 4 weeks",
  },
];

export const Gallery = () => {
  return (
    <div className="pt-10 px-6" data-testid="gallery-page">
      <p className="script text-2xl text-gold">the little moments</p>
      <h1 className="text-4xl font-serif text-espresso mb-2 leading-tight">Gallery</h1>
      <p className="text-mocha text-sm mb-6">A glimpse inside the studio and the glow that walks out.</p>

      {/* Bento grid */}
      <div className="grid grid-cols-2 gap-3 auto-rows-[140px]" data-testid="bento-grid">
        {items.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className={`relative rounded-2xl overflow-hidden group ${item.span}`}
            data-testid={`gallery-item-${i}`}
          >
            <img src={item.url} alt={item.label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-espresso/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
              <p className="text-cream text-xs font-serif">{item.label}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Before / After */}
      <div className="mt-12">
        <p className="script text-2xl text-gold">real results</p>
        <h2 className="text-3xl font-serif text-espresso mb-4">Before & after</h2>
        <div className="space-y-4">
          {beforeAfter.map((ba, i) => (
            <div key={i} className="bg-white rounded-[2rem] p-3 shadow-soft" data-testid={`before-after-${i}`}>
              <div className="grid grid-cols-2 gap-2">
                <div className="relative rounded-2xl overflow-hidden aspect-square">
                  <img src={ba.before} alt="before" className="w-full h-full object-cover" />
                  <span className="absolute top-2 left-2 bg-white/90 text-espresso text-[10px] px-2 py-1 rounded-full font-medium uppercase tracking-wider">Before</span>
                </div>
                <div className="relative rounded-2xl overflow-hidden aspect-square">
                  <img src={ba.after} alt="after" className="w-full h-full object-cover" />
                  <span className="absolute top-2 left-2 bg-blush text-espresso text-[10px] px-2 py-1 rounded-full font-medium uppercase tracking-wider">After</span>
                </div>
              </div>
              <p className="text-mocha text-xs text-center mt-3">{ba.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
